export const Lyuban = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.29931669145799, 52.487592376087434],
            [28.314215964195512, 52.487592376087434],
            [28.330314765913897, 52.487592376087434],
            [28.34641356853149, 52.48922619513286],
            [28.363406749621845, 52.49194909137765],
            [28.37771679619317, 52.49521634545812],
            [28.385766197052476, 52.502838992825446],
            [28.38844933067213, 52.5077385676808],
            [28.400970621197246, 52.52025722499104],
            [28.414386290195182, 52.52733140911738],
            [28.430485092812944, 52.534948487882446],
            [28.44658389543048, 52.542020306791756],
            [28.45999956352921, 52.54582773775991],
            [28.460009722108794, 52.54590185916709],
            [28.46178831957542, 52.55887927845612],
            [28.45821080748283, 52.587144300369346],
            [28.45463329539041, 52.602356382241396],
            [28.45016140662375, 52.624621687740785],
            [28.44658389543048, 52.644705049998095],
            [28.44837265057754, 52.65392945018402],
            [28.471626476480765, 52.663151904237054],
            [28.49130279029157, 52.670745405476055],
            [28.499352191150876, 52.6810487609917],
            [28.49336896920272, 52.68476094656057],
            [28.480346660969758, 52.69284040905768],
            [28.470564402325408, 52.6987689135546],
            [28.457987213539127, 52.70469661405764],
            [28.44680748937418, 52.71147014133413],
            [28.4314353686475, 52.718242619101716],
            [28.41606324881991, 52.72078202576995],
            [28.392306334969362, 52.72078202576995],
            [28.38252407722456, 52.730091923603425],
            [28.38671647288703, 52.74278403495538],
            [28.39510126601067, 52.758855402854635],
            [28.40767845569627, 52.761392446104594],
            [28.42165311090247, 52.761392446104594],
            [28.43562776520929, 52.77069367177569],
            [28.45239735145674, 52.780838197125206],
            [28.459354277007606, 52.789954388220906],
            [28.45698950314835, 52.79008439454162],
            [28.432884381207202, 52.79305373471874],
            [28.418153473004963, 52.79602287222423],
            [28.409672040927944, 52.797102508095065],
            [28.395387524454975, 52.79926169998453],
            [28.3873524832091, 52.801150905160796],
            [28.373960749296373, 52.80250028710651],
            [28.359229841093963, 52.80465921047801],
            [28.35119480074644, 52.80654818118052],
            [28.34003502188699, 52.80897673675082],
            [28.334678327423717, 52.81248441123131],
            [28.33333915403233, 52.81707094283968],
            [28.334678327423717, 52.82516364180685],
            [28.336463892544202, 52.83271546771135],
            [28.338695848495774, 52.83918741625217],
            [28.34360615033154, 52.843231894377766],
            [28.342713368669592, 52.85078057941354],
            [28.339142239326748, 52.85671076844227],
            [28.33333915403233, 52.861562138913655],
            [28.325750504515725, 52.86290964506264],
            [28.317715464168145, 52.862101146177906],
            [28.311019596313486, 52.861562138913655],
            [28.299859818352388, 52.86021459037602],
            [28.289592821154883, 52.85751936775972],
            [28.28289695419852, 52.85509352461082],
            [28.27352274045961, 52.85212842089038],
            [28.265041308382763, 52.85212842089038],
            [28.258345440528103, 52.85347622051711],
            [28.2556670937455, 52.858327952012075],
            [28.25477431208361, 52.86290964506264],
            [28.251203182740767, 52.86829925337679],
            [28.250756791011497, 52.878807063117506],
            [28.24540009744635, 52.88688826111593],
            [28.236472274538357, 52.887965640747666],
            [28.228437233292482, 52.88581085525129],
            [28.221294975505145, 52.88473342206919],
            [28.21236715259721, 52.88608020909203],
            [28.207903240694122, 52.88904299306273],
            [28.205671284742493, 52.89281351613249],
            [28.20076098200849, 52.89577583992764],
            [28.18870842148715, 52.894967953567175],
            [28.179780598579157, 52.89281351613249],
            [28.174423904115883, 52.89065897160464],
            [28.165049690376918, 52.88958165945104],
            [28.155675475739713, 52.888773657629656],
            [28.144515696880262, 52.88823498120104],
            [28.12799922445572, 52.88823498120104],
            [28.11282192542251, 52.88958165945104],
            [28.09809101722027, 52.89200557455257],
            [28.08202093652494, 52.89335213566653],
            [28.067736419153675, 52.893890747965486],
            [28.054791076071922, 52.89469865494749],
            [28.03916738530927, 52.896583711228914],
            [28.032471518353134, 52.90196913523641],
            [28.027561215618903, 52.90869997421987],
            [28.023990086276115, 52.91435307110771],
            [28.023990086276115, 52.920543711236746],
            [28.02979317157053, 52.92619526179817],
            [28.03157873579272, 52.92996255251859],
            [28.03291790918405, 52.93453667902304],
            [28.03291790918405, 52.937496150412755],
            [28.031132344961748, 52.94206948075009],
            [28.02890038901029, 52.94664232772976],
            [28.02890038901029, 52.95067679170671],
            [28.03336430091332, 52.95605549113924],
            [28.035596255966652, 52.95928238960926],
            [28.03336430091332, 52.96224016851619],
            [28.028453998179316, 52.963315674070714],
            [28.021758130324656, 52.96250904727776],
            [28.015955045928536, 52.95955128676519],
            [28.015062263368293, 52.95551765113538],
            [28.013723089976907, 52.95417302213116],
            [28.009259178073876, 52.951214691373366],
            [28.003009701948486, 52.94825615880052],
            [27.992742705649277, 52.944490460394434],
            [27.982029318519153, 52.94153146735732],
            [27.97176232132165, 52.93937934526008],
            [27.957031414017706, 52.93937934526008],
            [27.952567502114675, 52.94233848547918],
            [27.94899637277166, 52.94825615880052],
            [27.944532461766926, 52.951214691373366],
            [27.937390203081293, 52.9533662247689],
            [27.934711856298918, 52.95632440836209],
            [27.932926291178262, 52.96519774508903],
            [27.932033509516316, 52.97299402229987],
            [27.929355162733714, 52.97648844900374],
            [27.921766513217165, 52.97702602815741],
            [27.91596342792269, 52.977563600082306],
            [27.907928386676645, 52.98025136155616],
            [27.897761039770046, 52.98291287005861],
            [27.897661390377664, 52.98293895530071],
            [27.885162438126883, 52.98240145025096],
            [27.877573788610277, 52.9821326946776],
            [27.865074836359497, 52.980788893896204],
            [27.859271751963547, 52.97702602815741],
            [27.856147013451675, 52.97272520874992],
            [27.85659340428265, 52.96519774508903],
            [27.857039796011918, 52.95793787766428],
            [27.855700622620702, 52.953097289150605],
            [27.852129493277687, 52.94960097122265],
            [27.844987234592054, 52.94771822179996],
            [27.8342738474621, 52.94556640744179],
            [27.82356045943351, 52.94368348187129],
            [27.812400680574058, 52.94153146735732],
            [27.800348120052718, 52.93830324379951],
            [27.795884208149516, 52.93426762633055],
            [27.79142029624643, 52.930500710298304],
            [27.78650999441072, 52.92780985503276],
            [27.780706909116304, 52.92780985503276],
            [27.774903823821887, 52.928348039576065],
            [27.769547130256854, 52.92565705103209],
            [27.769547130256854, 52.92081284924001],
            [27.77088630364824, 52.91731392200478],
            [27.772225477039456, 52.91246878727583],
            [27.769547130256854, 52.90869997421987],
            [27.763297654131463, 52.905469302185054],
            [27.7566017871751, 52.90412311754932],
            [27.747227572537895, 52.905469302185054],
            [27.7378533587991, 52.905469302185054],
            [27.732496664335656, 52.903584631874594],
            [27.730264709282494, 52.899276507164984],
            [27.729818317553224, 52.8944293541129],
            [27.729480350513256, 52.89157475915465],
            [27.732050273504683, 52.891197617912326],
            [27.736960576238857, 52.88688826111593],
            [27.744995616586436, 52.880962196157725],
            [27.750798701880854, 52.87395762080348],
            [27.753477048663285, 52.867490854919424],
            [27.757048178006073, 52.85913652119933],
            [27.761958480740304, 52.85509352461082],
            [27.76776156603455, 52.84997185454762],
            [27.77356465043067, 52.84511918895436],
            [27.77356465043067, 52.841074886616354],
            [27.770439912817096, 52.83676054856227],
            [27.770439912817096, 52.83325483322875],
            [27.77401104215994, 52.827591157463246],
            [27.780528352783904, 52.82270362061615],
            [27.78509939776785, 52.8199413254934],
            [27.784813707456294, 52.815970219412634],
            [27.78081404309529, 52.81407086595732],
            [27.773671784409657, 52.812689466254085],
            [27.76595814510108, 52.81165338766721],
            [27.761387100117304, 52.80992653514721],
            [27.757387434858003, 52.8069907278923],
            [27.757387434858003, 52.804400145571776],
            [27.7585301970023, 52.800600345091595],
            [27.761958480740304, 52.79472727337043],
            [27.76310124198625, 52.79161767932186],
            [27.759949720204247, 52.78272765609353],
            [27.759949720204247, 52.775977261329444],
            [27.759949720204247, 52.76922581899055],
            [27.756462289591298, 52.763739500982524],
            [27.754369831223528, 52.76036296148044],
            [27.742512566241544, 52.75698616072464],
            [27.73414273187234, 52.75656404222218],
            [27.7201930085227, 52.755297662169994],
            [27.716533716721244, 52.75376647504709],
            [27.715390955475243, 52.75117272211662],
            [27.7162480264098, 52.74788708073578],
            [27.720533381980488, 52.74425529354835],
            [27.725675807587265, 52.74045023947548],
            [27.730532543781067, 52.736125911739066],
            [27.735175012016498, 52.7320065903873],
            [27.740531705581702, 52.72660006560295],
            [27.74410283492449, 52.72200399285464],
            [27.74410283492449, 52.716055415359335],
            [27.747227572537895, 52.711728667117484],
            [27.752584266103042, 52.708212868122814],
            [27.758833742228433, 52.707401489744996],
            [27.76642239174504, 52.707401489744996],
            [27.77713577977346, 52.705778687727445],
            [27.781153299947277, 52.70415582536009],
            [27.789634732024297, 52.69982789696593],
            [27.794991425589274, 52.696040607696204],
            [27.801240901714664, 52.69171187457545],
            [27.805704813617695, 52.685759166386674],
            [27.810615116351926, 52.67547530336327],
            [27.810615116351926, 52.67141521749079],
            [27.811061507182842, 52.664106111540264],
            [27.813739853965444, 52.65706655806895],
            [27.817757374139205, 52.65246316004277],
            [27.822667676873266, 52.647859277293094],
            [27.82802437133671, 52.64596341968462],
            [27.8342738474621, 52.645692576407555],
            [27.839184150196104, 52.645692576407555],
            [27.84632640798344, 52.64677593999659],
            [27.853915057500046, 52.64731761199948],
            [27.859718142794463, 52.645150884276575],
            [27.865074836359497, 52.64162972269793],
            [27.868199574871312, 52.63946271371856],
            [27.870877921653914, 52.63567018885817],
            [27.874895441827675, 52.6326901171999],
            [27.879359353730763, 52.63187733520493],
            [27.884269656464937, 52.63404471994329],
            [27.8882871766387, 52.63567018885817],
            [27.897661390377664, 52.634315635895575],
            [27.89944695549815, 52.63323196311188],
            [27.900786128889536, 52.62943889808588],
            [27.900786128889536, 52.62591647220569],
            [27.902125302280695, 52.62401966344936],
            [27.903018084841108, 52.61995479721429],
            [27.899893346329122, 52.61588955348225],
            [27.896322216986277, 52.61534749228014],
            [27.8909655234213, 52.61209498521822],
            [27.890519132590327, 52.60884223599464],
            [27.89453665276409, 52.603149344396854],
            [27.896768608715718, 52.597184568649595],
            [27.901232519720452, 52.59013424131393],
            [27.903018084841108, 52.583625239530704],
            [27.903018084841108, 52.57684400155864],
            [27.901232519720452, 52.569790401450746],
            [27.903018084841108, 52.56544916021721],
            [27.906589213285486, 52.5605647505771],
            [27.91596342792269, 52.559479251986204],
            [27.92444485999971, 52.5605647505771],
            [27.931140726956073, 52.56165022176242],
            [27.940961332424138, 52.56300702338331],
            [27.950781937892316, 52.56246430766174],
            [27.95970976080031, 52.55785095428416],
            [27.963280890143153, 52.554051357770845],
            [27.967744801147887, 52.54997999655967],
            [27.969530366268373, 52.54617971843567],
            [27.969530366268373, 52.54265059390099],
            [27.969530366268373, 52.537763645839846],
            [27.973994277273277, 52.53151842033952],
            [27.97711901578515, 52.527716543758345],
            [27.981582926789883, 52.52418593489085],
            [27.9873860120843, 52.520655042224405],
            [27.99363548820969, 52.51766714281479],
            [28.000147795898897, 52.51440347930571],
            [28.00207807234534, 52.517536080625746],
            [28.01907125253632, 52.51808032334827],
            [28.03606443272747, 52.51644757629464],
            [28.048585723252643, 52.51644757629464],
            [28.071839550055245, 52.517536080625746],
            [28.087043974200185, 52.520801433539305],
            [28.1085090440572, 52.52188982995176],
            [28.121030334582372, 52.523522374657944],
            [28.137129137199906, 52.52569900650411],
            [28.148756049252427, 52.52134563489318],
            [28.148756049252427, 52.51263759754721],
            [28.155911073437323, 52.50066122873284],
            [28.1550166949645, 52.49249365066157],
            [28.163066095823808, 52.487047756548805],
            [28.18095365448761, 52.49303820365037],
            [28.19973559072497, 52.495760864272484],
            [28.207784991584276, 52.495760864272484],
            [28.217623149388942, 52.49194909137765],
            [28.224778172674633, 52.485413856564264],
            [28.231933195960266, 52.477788188374234],
            [28.24803199857803, 52.48051179238536],
            [28.26681393391607, 52.484869210046156],
            [28.282018358960215, 52.485958496787305],
            [28.29632840553154, 52.487592376087434],
            [28.29931669145799, 52.487592376087434],
          ],
        ],
      },
      properties: {
        shapeName: "Lyuban",
        shapeISO: "",
        shapeID: "67162791B60458568388386",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
